import { render } from "./IndividualInfoStudent.vue?vue&type=template&id=8b1a7934&scoped=true"
import script from "./IndividualInfoStudent.vue?vue&type=script&lang=js"
export * from "./IndividualInfoStudent.vue?vue&type=script&lang=js"

import "./IndividualInfoStudent.vue?vue&type=style&index=0&id=8b1a7934&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1a7934"]])

export default __exports__